
































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import UiAccordion from '@/components/semantic-ui/Accordion'
import UiButton from '@/components/semantic-ui/Button'
import UiModal from '@/components/semantic-ui/Modal.vue'

import * as constants from '@/constants'

import { Brand, Category, PantryItem } from '@/datastore/models'

import grocery from '@/store/modules/grocery'

import PantryCategoryList from './PantryCategoryList.vue'
import PantryUncategorizedList from './PantryUncategorizedList.vue'

@Component({
	components: {
		PantryCategoryList,
		PantryUncategorizedList,
		UiAccordion,
		UiButton,
		UiModal,
	},
})
export default class PantryList extends Vue {

	$refs!: {
		'accordion': InstanceType<typeof UiAccordion>,
		'delete-category-modal': UiModal
		'delete-item-modal': UiModal
	}

	@Prop({ required: true })
	readonly categories!: Category[]

	@Prop({ default: '' })
	readonly filter!: string

	@Prop({ default: false })
	readonly showUncategorized!: boolean

	readonly CATEGORIES_PER_PAGE = 15

	activeCategoryId: string | null = null

	category: Category = { $id: '', color: 'white', icon: 'layers', name: '' }

	pantryItem: PantryItem = { $id: '', name: '', notes: '' }

	get categoryCount(): number {

		return this.filteredCategories.length + (this.showUncategorized ? 1 : 0)
	}

	get filteredCategories(): Category[] {

		let { categories, filter } = this

		if (!filter) {
			return categories
		}

		const matches = matchesFilter.bind(undefined, filter.toLocaleLowerCase())

		return categories.filter(category => this.getCategorySearchIndex(category).some(matches))
	}

	get offset(): number {

		return this.CATEGORIES_PER_PAGE * this.page
	}

	get page(): number {

		return (typeof this.$route.query.page === 'string')
			? parseInt(this.$route.query.page) || 0
			: 0
	}

	get pageCount(): number {

		return Math.ceil(this.categoryCount / this.CATEGORIES_PER_PAGE)
	}

	get paginatedCategories(): Category[] {

		return this.filteredCategories.slice(this.offset, this.offset + this.CATEGORIES_PER_PAGE)
	}

	deleteCategory(): boolean {

		grocery.deleteCategory(this.category.$id)

		return true
	}

	deletePantryItem(): boolean {

		if (this.pantryItem) {
			grocery.deletePantryItem(this.pantryItem.$id)
		}

		return true
	}

	getCategorySearchIndex(category: Category): string[] {

		const pantryItems = (grocery.categoryPantryItems[category.$id] ?? [])
			.map(pantryItemId => grocery.pantryItemsCollection[pantryItemId])
			.filter<PantryItem>((i): i is PantryItem => !!i)

		const brands = pantryItems
			.map(pantryItem => grocery.pantryItemBrands[pantryItem.$id] ?? [])
			.filter(brands => brands.length > 0)
			.map(brands => brands.map(b => grocery.brandsCollection[b]))
			.reduce((flatten, array) => [...flatten, ...array], [])
			.filter((brand): brand is Brand => !!brand)

		return [
			category.name,
			...pantryItems.map(pantryItem => pantryItem.name),
			...brands.map(brand => brand.name),
		]
	}

	mounted() {

		const activeCategoryId = sessionStorage.getItem(constants.sessionStorage.ACTIVE_CATEGORY_ID)

		this.activeCategoryId = activeCategoryId

		const activeCategoryIndex = this.paginatedCategories.findIndex(c => c.$id === activeCategoryId)
		if (activeCategoryIndex !== -1) {
			this.$refs['accordion'].open(activeCategoryIndex)
			const el = document.querySelector(`[data-category="${activeCategoryId}"]`)
			if (el) {
				Vue.nextTick(() => el.scrollIntoView())
			}
		}
	}

	promptDeleteCategory(category: Category): void {

		this.category = category
		this.$refs['delete-category-modal'].show()
	}

	promptDeletePantryItem(pantryItem: PantryItem): void {

		this.pantryItem = pantryItem
		this.$refs['delete-item-modal'].show()
	}

	onClose(el: HTMLElement[]): void {

		this.activeCategoryId = null
		sessionStorage.removeItem(constants.sessionStorage.ACTIVE_CATEGORY_ID)
		sessionStorage.removeItem(constants.sessionStorage.ACTIVE_PANTRY_ITEM_ID)
	}

	onOpen(el: HTMLElement): void {

		this.activeCategoryId = el.dataset['category'] ?? null

		if (this.activeCategoryId) {
			sessionStorage.setItem(constants.sessionStorage.ACTIVE_CATEGORY_ID, this.activeCategoryId)
		}
		else {
			sessionStorage.removeItem(constants.sessionStorage.ACTIVE_CATEGORY_ID)
		}
	}

	@Watch('filter')
	onWatchFilter(): void {

		this.$router.push({ path: this.$route.path, query: { page: '0' } })
	}

}

function matchesFilter(filter: string, searchIndex: string): boolean {

	return searchIndex.toLocaleLowerCase().includes(filter)
}

